<template>
  <div class="indicators-block">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  .indicators-block {
    display: flex;
    gap: 10px;
  }
</style>